import request from "@/utils/request";
import Qs from "qs";

const api = {
  findPage: "/api/user/findPage",
  save: "/api/user/save",
  del: "/api/user/updateUserStatus",
  updatePassWord: "/api/user/updatePassWord",
  resetPassWord: "/api/user/resetPassWord",
  findAll: "/api/user/findAll",
  teacherFindPage: "openapi/jWorkers/findPageWorkers"
};

/**
 * 功能描述：教师管理列表分页 <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 14:14 2021/2/26
 **/
export function teacherFindPage(parameter) {
  return request({
    url: api.teacherFindPage,
    method: "get",
    params: parameter
  });
}

export function findPage(parameter) {
  return request({
    url: api.findPage,
    method: "get",
    params: parameter
  });
}

export function findAll(parameter) {
  return request({
    url: api.findAll,
    method: "get",
    params: parameter
  });
}
export function save(parameter) {
  return request({
    url: api.save,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

export function del(parameter) {
  return request({
    url: api.del,
    method: "post",
    data: Qs.stringify(parameter)
  });
}
export function updatePassWord(parameter) {
  return request({
    url: api.updatePassWord,
    method: "post",
    data: Qs.stringify(parameter)
  });
}
export function resetPassWord(parameter) {
  return request({
    url: api.resetPassWord,
    method: "post",
    data: Qs.stringify(parameter)
  });
}
